import React from "react";

const DeepSeekUserSchoolBreakdown = ({ stats, t }) => {
    return (
        <>
            {/* User and School Utilization */}
            <div className="deepseek-stats-section-title">
                {t('Pages.DeepSeekAdmin.userAndSchoolStats') || "نشاط المستخدمين والمدارس (المدارس)"}
            </div>
            <div className="deepseek-stats-grid triple">
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.monthlyUsers') || "المستخدمين النشطين شهرياً"}</h6>
                        <i className="fal fa-users-crown text-primary" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-primary">
                        {stats ? stats.MonthlyUsers : 0}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.totalUsers') || "إجمالي المستخدمين الفريدين"}</h6>
                        <i className="fal fa-users text-info" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-info">
                        {stats ? stats.TotalUsers : 0}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.schoolStatsTitle') || "المدارس المستفيدة"}</h6>
                        <i className="fal fa-school text-success" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-success">
                        {stats ? stats.SchoolCount : 0}
                    </div>
                </div>
            </div>

            {/* User Type Breakdown Section */}
            <div className="deepseek-stats-section-title">
                <i className="fal fa-users-class ml-2 text-primary" style={{ fontSize: '18px' }}></i>
                {t('Pages.DeepSeekAdmin.userTypeBreakdownTitle') || "توزيع نشاط فئات المستخدمين المدارس"}
            </div>
            <div className="deepseek-distribution-card mb-4 text-right animate__animated animate__fadeIn" style={{ direction: 'rtl' }}>
                <div className="table-responsive">
                    <table className="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th>{t('Pages.DeepSeekAdmin.userTypeName') || "الفئة"}</th>
                                <th>{t('Pages.DeepSeekAdmin.userCountLabel') || "عدد المستخدمين"}</th>
                                <th>{t('Pages.DeepSeekAdmin.conversationsCountLabel') || "عدد المحادثات"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stats?.UserTypeBreakdown && stats.UserTypeBreakdown.length > 0 ? (
                                stats.UserTypeBreakdown.map((ut, idx) => (
                                    <tr key={idx}>
                                        <td className="font-weight-bold text-dark">{ut.UserTypeName || `فئة ${ut.UserTypeId}`}</td>
                                        <td><span className="badge bg-soft-primary text-primary px-3 py-2 font-weight-bold">{ut.UserCount}</span></td>
                                        <td><span className="badge bg-soft-success text-success px-3 py-2 font-weight-bold">{ut.ConversationCount}</span></td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center text-muted small py-3">
                                        {t('Pages.DeepSeekAdmin.noGroupData')}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Top User & Top School Side-by-Side (UserType 3,4,5) */}
            <div className="row g-4 mb-4 text-right animate__animated animate__fadeIn" style={{ direction: 'rtl' }}>
                <div className="col-md-6 col-12">
                    <div className="deepseek-stats-section-title">
                        <i className="fal fa-user-crown ml-2 text-warning" style={{ fontSize: '18px' }}></i>
                        {t('Pages.DeepSeekAdmin.topUserMonthly') || "أكثر مستخدم نشاطاً خلال الشهر الحالي (المدارس)"}
                    </div>
                    <div className="deepseek-distribution-card p-4">
                        {stats?.TopUserMonthly ? (
                            <div>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar-circle-sm bg-soft-primary text-primary ml-3 font-weight-bold d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px', borderRadius: '50%', fontSize: '18px' }}>
                                        {(stats.TopUserMonthly.FullName || "U")[0]}
                                    </div>
                                    <div>
                                        <h5 className="mb-0 font-weight-bold text-dark" style={{ fontSize: '16px' }}>{stats.TopUserMonthly.FullName}</h5>
                                        <span className="text-muted small">@{stats.TopUserMonthly.Username}</span>
                                    </div>
                                </div>
                                <div className="row text-center mt-3">
                                    <div className="col-4 border-left">
                                        <div className="text-muted small mb-1">{t('Pages.DeepSeekAdmin.requestsCountLabel') || "عدد الطلبات"}</div>
                                        <strong className="text-dark" style={{ fontSize: '15px' }}>{stats.TopUserMonthly.RequestCount}</strong>
                                    </div>
                                    <div className="col-4 border-left">
                                        <div className="text-muted small mb-1">{t('Pages.DeepSeekAdmin.totalCostLabel') || "إجمالي التكلفة"}</div>
                                        <strong className="text-danger" style={{ fontSize: '15px' }}>${stats.TopUserMonthly.TotalSpent.toFixed(4)}</strong>
                                    </div>
                                    <div className="col-4">
                                        <div className="text-muted small mb-1">{t('Pages.DeepSeekAdmin.avgRequestCostLabel') || "متوسط تكلفة المحادثة"}</div>
                                        <strong className="text-success" style={{ fontSize: '15px' }}>${stats.TopUserMonthly.AvgCost.toFixed(5)}</strong>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-5 text-muted small">
                                {t('Pages.DeepSeekAdmin.noUserMonthlyData') || "لا توجد بيانات مستخدمين للمدارس هذا الشهر"}
                            </div>
                        )}
                    </div>
                </div>

                <div className="col-md-6 col-12">
                    <div className="deepseek-stats-section-title">
                        <i className="fal fa-school ml-2 text-success" style={{ fontSize: '18px' }}></i>
                        {t('Pages.DeepSeekAdmin.topSchool') || "أكثر مدرسة نشاطاً وتفاعلاً (المدارس)"}
                    </div>
                    <div className="deepseek-distribution-card p-4">
                        {stats?.TopSchool ? (
                            <div>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar-circle-sm bg-soft-success text-success ml-3 font-weight-bold d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px', borderRadius: '50%', fontSize: '18px' }}>
                                        <i className="fal fa-school"></i>
                                    </div>
                                    <div>
                                        <h5 className="mb-0 font-weight-bold text-dark" style={{ fontSize: '16px' }}>{stats.TopSchool.SchoolName}</h5>
                                    </div>
                                </div>
                                <div className="row text-center mt-3">
                                    <div className="col-4 border-left">
                                        <div className="text-muted small mb-1">{t('Pages.DeepSeekAdmin.requestsCountLabel') || "عدد الطلبات"}</div>
                                        <strong className="text-dark" style={{ fontSize: '15px' }}>{stats.TopSchool.RequestCount}</strong>
                                    </div>
                                    <div className="col-4 border-left">
                                        <div className="text-muted small mb-1">{t('Pages.DeepSeekAdmin.totalCostLabel') || "إجمالي التكلفة"}</div>
                                        <strong className="text-danger" style={{ fontSize: '15px' }}>${stats.TopSchool.TotalSpent.toFixed(4)}</strong>
                                    </div>
                                    <div className="col-4">
                                        <div className="text-muted small mb-1">{t('Pages.DeepSeekAdmin.avgRequestCostLabel') || "متوسط تكلفة المحادثة"}</div>
                                        <strong className="text-success" style={{ fontSize: '15px' }}>${stats.TopSchool.AvgCost.toFixed(5)}</strong>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-5 text-muted small">
                                {t('Pages.DeepSeekAdmin.noSchoolData') || "لا توجد بيانات للمدارس"}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeepSeekUserSchoolBreakdown;
